/**
 *  Purpose of this collection of method is that we're forced to fixed data we're receiving from API
 *  on Front-end site. Please feel free to add 'Utils' method with this kind of purpose
 */

/**
 * Api return unit of measure for Tons as TO and it should be displayed as TN
 */
export function tonUnitConverter(unit: string): string {
  return unit === 'TO' ? 'TN' : unit;
}
